import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/layout/Contact.css'
import { Container, Row, Col, Form } from 'react-bootstrap';
import EmailIcon from '@mui/icons-material/Email';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import ReCAPTCHA from "react-google-recaptcha";

// The live key is registered to the 42cards domain, so Google refuses to render
// the widget anywhere else ("… is not in the list of supported domains").
const LIVE_SITE_KEY = '6LeVsH0hAAAAACqssMqzsSkl1dfLlEE6Ql5_hySa';

// Google's publicly documented test key. Always issues a passing token and
// shows a "for testing purposes only" notice.
// https://developers.google.com/recaptcha/docs/faq
const TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

/** Loopback, private LAN ranges and .local — i.e. anywhere but the real site. */
const isLocalHost = () => {
    if (typeof window === 'undefined') return false
    const h = window.location.hostname
    return (
        h === 'localhost' ||
        h === '0.0.0.0' ||
        h === '[::1]' ||
        h === '::1' ||
        h.endsWith('.local') ||
        h.endsWith('.localhost') ||
        /^127\./.test(h) ||
        /^10\./.test(h) ||
        /^192\.168\./.test(h) ||
        /^172\.(1[6-9]|2\d|3[01])\./.test(h)
    )
}

// Decided at render time from the actual hostname, so it works without an env
// file, without restarting the dev server, and when serving a production build
// locally. An explicit env var still wins if one is set.
const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
    (isLocalHost() ? TEST_SITE_KEY : LIVE_SITE_KEY);

const Result = () => {
    return(
        <div className="contactForm__result">
            <CheckCircleOutlineRoundedIcon fontSize="small" />
            <p>Your message has been sent successfully!</p>
        </div>
    )
}

const Contactus = () => {
    const [result, setResult] =useState(false)

    const form = useRef();
    const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_9kgyhxf', 'template_hf1be7k', form.current, 'N8E7v4KNRh_GvIfmB')
      .then((result) => {
          console.log(result.text);
          console.log('Message Sent')
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
      setResult(true)
  };

const [verified, setVerified] = useState(false)

// Recaptcha Function
function onChange(value) {
    console.log("Captcha value:", value);
    setVerified(true)
}

  return (
    <section className="contact-us section">
        <span className="aurora aurora--low" aria-hidden="true" />
        <Container>
            <div className="reveal">
                <h2>Transform Your Credit Cards Business</h2>
                <span className="rule" />
            </div>
            <div className="contact-us__grid">
                <div className="contact-left reveal reveal--left">
                    <p>
                        Be one step ahead in today’s fast-paced competitive environment and make your customers
                        choose you over others by offering a complete and customised credit cards experience.
                        Partner with us and we’ll help you with everything that your bank needs in order to
                        provide your customer with solutions that meet their unique requirements.
                    </p>
                    <div className="emailId">
                        <a href='mailto:info@42cards.in' className="contactTile card-x">
                            <span className="contactTile__icon" aria-hidden="true">
                                <EmailIcon />
                            </span>
                            <span className="contactTile__body">info@42cards.in</span>
                        </a>
                        <div className="contactTile card-x">
                            <span className="contactTile__icon" aria-hidden="true">
                                <PlaceOutlinedIcon />
                            </span>
                            <span className="contactTile__body">
                                <span className='subaddress_contact'>42 Card Solutions Private Limited,</span>
                                <span className='subaddress_contact'>559, 2nd floor, AECS Layout Main Rd,</span>
                                <span className='subaddress_contact'>Sri Nivasa Reddy Layout, AECS Layout, Marathahalli,</span>
                                <span className='subaddress_contact'>Bengaluru, Karnataka - 560037.</span>
                                <span className='subaddress_contact'>CIN Number : U72900KA2020PTC141127</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="contact-right card-x reveal reveal--right" data-delay="1">
                    <p>
                        We are happy to answer your questions. Please submit
                        your query below and we will get in touch with you.
                    </p>
                    <div className="contactForm">
                    <Form ref={form} onSubmit={sendEmail}>
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Group controlId="yourName">
                                    <Form.Control
                                    type="text"
                                    placeholder="Your Name*"
                                    name="user_name"
                                    required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="yourEmail">
                                    <Form.Control
                                    type="email"
                                    placeholder="Email*"
                                    name="user_email"
                                    required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group controlId="yourOrganization">
                                    <Form.Control
                                    type="text"
                                    placeholder="Organization*"
                                    name="user_organization"
                                    required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group controlId="message">
                                    <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Message"
                                    name="user_message"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="contactForm__captcha">
                            <ReCAPTCHA
                                sitekey={RECAPTCHA_SITE_KEY}
                                theme="light"
                                onChange={onChange}
                            />
                        </div>
                        <button
                            type="submit"
                            value="Send"
                            className="btn-42 btn-42--primary"
                            disabled={!verified}
                            >
                            Submit
                            <EastRoundedIcon fontSize="small" />
                        </button>
                    </Form>
                    <div>
                        {result ? <Result /> : null }
                    </div>
                    </div>
                </div>
            </div>
        </Container>
    </section>
  )
}

export default Contactus
